// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._equipmentItem_1qv63_1 {
  /* Typography */
  --pa-equipment-item-value-font-family-inner: var(
    --pa-equipment-item-value-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --pa-equipment-item-value-font-size-inner: var(
    --pa-equipment-item-value-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --pa-equipment-item-value-line-height-inner: var(
    --pa-equipment-item-value-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --pa-equipment-item-value-font-weight-inner: var(--pa-equipment-item-value-font-weight, 700);
  --pa-equipment-item-value-letter-spacing-inner: var(
    --pa-equipment-item-value-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --pa-equipment-item-value-text-transform-inner: var(
    --pa-equipment-item-value-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --pa-equipment-item-value-color-inner: var(
    --pa-equipment-item-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
}
._equipmentItem__itemValue_1qv63_30 {
  text-align: end;
  --perxis-auto-typography-main-font-family: var(--pa-equipment-item-value-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--pa-equipment-item-value-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--pa-equipment-item-value-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--pa-equipment-item-value-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--pa-equipment-item-value-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--pa-equipment-item-value-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--pa-equipment-item-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--pa-equipment-item-value-line-height-inner);
}
._equipmentItem__singleTable_1qv63_52 {
  padding-top: var(--perxis-auto-gap-vertical-sky-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-sky-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
